export default "<p>impact works!</p>\r\n"